import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';

class _Control extends compose(_WidgetBaseSP) {
    [key: string]: any;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    _setupSubscriptions(): void {
        super._setupSubscriptions.apply(this, arguments as any);
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
}
_Control.prototype.declaredClass = 'more.Legacy.Zal.Switchable._Control';

export default mdsWidget(_Control);
